import axios from '../../helpers/axios-setup';
import { SingleProductRecord } from '../../components/pages/product/types';

export const updateProductInfo = (id: number, data: Partial<SingleProductRecord>) =>
  axios.patch(`/product-models/${id}`, data);
